module.exports = __webpack_public_path__ + "static/img/2_1_11.9f12e643.jpg";